import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Tooltip,
  LinearProgress,
  Grid,
  Card,
  CardContent,
  IconButton,
  Tabs,
  Tab,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Avatar,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  ContentCopy as ContentCopyIcon,
  WhatsApp as WhatsAppIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon,
  Celebration as CelebrationIcon,
  EmojiEvents as EmojiEventsIcon,
  Share as ShareIcon,
  Redeem as RedeemIcon,
  QrCode as QrCodeIcon,
  BarChart as BarChartIcon,
  Campaign as CampaignIcon,
  Send as SendIcon,
  FlightTakeoff as FlightTakeoffIcon,
  PersonAdd as PersonAddIcon,
  Luggage as LuggageIcon,
  CardGiftcard as CardGiftcardIcon,
} from "@mui/icons-material";
// Add these imports with your other icon imports at the top of the file
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import CloseIcon from '@mui/icons-material/Close';
// Mocked QR code component (would use a proper QR library in production)
const QRCode = ({ value }) => (
  <Box
    sx={{
      width: 150,
      height: 150,
      bgcolor: "#f5f5f5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto",
      position: "relative",
      overflow: "hidden",
      borderRadius: "8px",
    }}
  >
    <QrCodeIcon sx={{ fontSize: 100, opacity: 0.7, color: "#FF5733" }} />
    <Typography
      variant="caption"
      sx={{
        position: "absolute",
        bottom: 5,
        width: "100%",
        textAlign: "center",
      }}
    >
      {value.substring(0, 15)}...
    </Typography>
  </Box>
);
export const CustomerReferralPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // State variables
  const userId = "123456"; // placeholder user ID
  const userName = "Rajesh Kumar"; // placeholder user name
  const [activeTab, setActiveTab] = useState(0);
  const [copySuccess, setCopySuccess] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [customMessageOpen, setCustomMessageOpen] = useState(false);
  const [customMessage, setCustomMessage] = useState(
    `Hey! I've been using Atithi Airport Seva for my airport assistance needs and thought you might like it too. You can get ₹200 off your first booking by using my referral link!`
  );
  const [selectedChannel, setSelectedChannel] = useState("");
  const referralBaseUrl = "https://atithiairportseva.com/signup";
  const referralCode = `ATITHI${userId}`;
  const referralLink = `${referralBaseUrl}?ref=${referralCode}`;

  // Reward tiers configuration
  const rewardTiers = [
    { count: 3, reward: "₹600 credit", unlocked: true },
    { count: 5, reward: "₹1200 credit", unlocked: false },
    { count: 10, reward: "₹3000 credit + 1 Free VIP service", unlocked: false },
    {
      count: 25,
      reward: "₹8000 credit + 1 Year Priority Access",
      unlocked: false,
    },
  ];

  // Referral data with expanded information
  const referralData = [
    {
      name: "Priya Sharma",
      date: "15-04-2024",
      status: "Converted",
      reward: "₹200 credit",
      activity: "Booked VIP service",
      service: "Meet & Greet",
    },
    {
      name: "Amit Patel",
      date: "20-04-2024",
      status: "Pending",
      reward: "Pending",
      activity: "Visited signup",
      service: "-",
    },
    {
      name: "Neha Gupta",
      date: "05-04-2024",
      status: "Converted",
      reward: "₹200 credit",
      activity: "Booked Economy service",
      service: "Baggage Assistance",
    },
    {
      name: "Vikram Singh",
      date: "28-03-2024",
      status: "Converted",
      reward: "₹200 credit",
      activity: "Booked Premium service",
      service: "Fast Track",
    },
    {
      name: "Meera Reddy",
      date: "12-03-2024",
      status: "Expired",
      reward: "-",
      activity: "Never activated",
      service: "-",
    },
  ];

  // Performance metrics
  const metrics = {
    conversionRate: 60,
    avgTimeToConversion: "2.3 days",
    topChannel: "WhatsApp",
    totalEarned: "₹600",
    pendingRewards: "₹200",
  };

  // Campaign templates - FIXED: Create icon elements instead of passing component references
  const campaignTemplates = [
    {
      name: "Friends & Family",
      message:
        "Hey! I use Atithi Airport Seva for hassle-free airport experiences. Use my referral link to get ₹200 off your first booking, and I'll get a reward too!",
      // Fixed: rendering the icon component directly as JSX
      icon: <CelebrationIcon />,
    },
    {
      name: "Business Travel",
      message:
        "I'd like to recommend Atithi Airport Seva for your business travel needs. Their airport assistance services have saved me so much time and stress. Get ₹200 off with my referral link.",
      icon: <LinkedInIcon />,
    },
    {
      name: "Special Offer",
      message:
        "Planning air travel? Use my Atithi Airport Seva referral link for ₹200 off your first booking! Their meet & greet and fast track services are excellent.",
      icon: <CampaignIcon />,
    },
  ];

  // Reset copy success message after timeout
  useEffect(() => {
    if (copySuccess) {
      const timer = setTimeout(() => setCopySuccess(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [copySuccess]);

  // Copy-to-clipboard handler
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => setCopySuccess(true))
      .catch((err) => console.error("Copy failed", err));
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case "Converted":
        return "success";
      case "Pending":
        return "warning";
      case "Expired":
        return "error";
      default:
        return "default";
    }
  };

  // Calculate progress towards next tier
  const currentReferrals = referralData.filter(
    (r) => r.status === "Converted"
  ).length;
  const currentTierIndex = rewardTiers.findIndex(
    (tier) => tier.count > currentReferrals
  );
  const previousTierCount =
    currentTierIndex > 0 ? rewardTiers[currentTierIndex - 1].count : 0;
  const nextTierCount =
    currentTierIndex >= 0
      ? rewardTiers[currentTierIndex].count
      : rewardTiers[rewardTiers.length - 1].count;
  const progressToNextTier =
    ((currentReferrals - previousTierCount) /
      (nextTierCount - previousTierCount)) *
    100;

  // Share via social media
  const handleShare = (channel) => {
    setSelectedChannel(channel);
    setCustomMessageOpen(true);
  };

  // Send custom message
  const handleSendCustomMessage = () => {
  
    setCustomMessageOpen(false);
    // Show success message
    alert(`Shared via ${selectedChannel}!`);
  };

  // Select template message
  const selectTemplate = (message) => {
    setCustomMessage(message);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Page Header */}
      <Paper
        elevation={3}
        sx={{
          mb: 4,
          p: 3,
          background: "linear-gradient(135deg, #FF5733 0%, #FF8C33 100%)",
          color: "white",
          borderRadius: "12px",
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={8}>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
              Atithiairportseva Referral
            </Typography>
            <Typography variant="subtitle1" sx={{ mt: 1 }}>
              Refer friends to earn rewards and make their airport experience
              smoother
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ textAlign: { xs: "left", md: "right" } }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="large"
              startIcon={<ShareIcon />}
              onClick={() => setShareModalOpen(true)}
              sx={{
                px: 3,
                py: 1.5,
                fontWeight: 600,
                bgcolor: "white",
                color: "#FF5733",
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              Share Now
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabs Navigation */}
      <Paper sx={{ mb: 3, borderRadius: "12px", overflow: "hidden" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#FF5733",
              height: 3,
            },
            "& .Mui-selected": {
              color: "#FF5733 !important",
              fontWeight: 600,
            },
          }}
        >
          <Tab
            label="Your Referrals"
            icon={<PersonAddIcon />}
            iconPosition="start"
            sx={{ py: 2 }}
          />
          <Tab
            label="Your Rewards"
            icon={<CardGiftcardIcon />}
            iconPosition="start"
            sx={{ py: 2 }}
          />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      {activeTab === 0 && (
        <>
          {/* Referral Link Section */}
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              mb: 4,
              borderRadius: "12px",
              border: "1px solid #f0f0f0",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "#333", fontWeight: 600 }}
            >
              Your Personal Referral Link
            </Typography>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f9f9f9",
                    p: 2,
                    borderRadius: "8px",
                    border: "1px solid #eaeaea",
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      wordBreak: "break-all",
                      fontWeight: "medium",
                      color: "#333",
                      fontSize: "0.9rem",
                    }}
                  >
                    {referralLink}
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<ContentCopyIcon />}
                    onClick={copyToClipboard}
                    size="small"
                    sx={{
                      bgcolor: "#FF5733",
                      color: "white",
                      "&:hover": {
                        bgcolor: "#E64A2E",
                      },
                    }}
                  >
                    Copy
                  </Button>
                </Box>
                {copySuccess && (
                  <Typography color="success.main" sx={{ mt: 1 }}>
                    Link copied to clipboard!
                  </Typography>
                )}

                <Box sx={{ mt: 3, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{ color: "#555", fontWeight: 500 }}
                  >
                    How it works:
                  </Typography>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} sm={4}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                          p: 1,
                        }}
                      >
                        <Avatar sx={{ bgcolor: "#FF8C33", mb: 1 }}>1</Avatar>
                        <Typography variant="body2">
                          Share your unique link with friends
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                          p: 1,
                        }}
                      >
                        <Avatar sx={{ bgcolor: "#FF8C33", mb: 1 }}>2</Avatar>
                        <Typography variant="body2">
                          They book an airport service
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                          p: 1,
                        }}
                      >
                        <Avatar sx={{ bgcolor: "#FF8C33", mb: 1 }}>3</Avatar>
                        <Typography variant="body2">
                          You both get ₹200 credit!
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Typography
                    variant="body1"
                    sx={{ mb: 2, fontWeight: 500, color: "#555" }}
                  >
                    Share directly:
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        variant="contained"
                        startIcon={<WhatsAppIcon />}
                        onClick={() => handleShare("WhatsApp")}
                        sx={{
                          bgcolor: "#25D366",
                          "&:hover": {
                            bgcolor: "#1da851",
                          },
                        }}
                      >
                        WhatsApp
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        startIcon={<FacebookIcon />}
                        onClick={() => handleShare("Facebook")}
                        sx={{
                          bgcolor: "#1877F2",
                          "&:hover": {
                            bgcolor: "#1559b3",
                          },
                        }}
                      >
                        Facebook
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        startIcon={<EmailIcon />}
                        onClick={() => handleShare("Email")}
                        sx={{
                          bgcolor: "#757575",
                          "&:hover": {
                            bgcolor: "#5a5a5a",
                          },
                        }}
                      >
                        Email
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <QRCode value={referralLink} />
                  <Typography variant="body2" sx={{ mt: 2, color: "#555" }}>
                    Scan to share your link
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mt: 1, color: "#777" }}
                  >
                    Your referral code: <strong>{referralCode}</strong>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* Referral Progress */}
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              mb: 4,
              borderRadius: "12px",
              border: "1px solid #f0f0f0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ color: "#333", fontWeight: 600 }}>
                Your Referral Progress
              </Typography>
              <Chip
                icon={<CelebrationIcon sx={{ color: "white !important" }} />}
                label={`${currentReferrals} Successful Referrals`}
                sx={{
                  bgcolor: "#FF5733",
                  color: "white",
                  fontWeight: 500,
                  "& .MuiChip-icon": {
                    color: "white",
                  },
                }}
              />
            </Box>

            <Box sx={{ mb: 4 }}>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
              >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {currentTierIndex > 0
                    ? `${rewardTiers[currentTierIndex - 1].count} referrals`
                    : "0 referrals"}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {currentTierIndex >= 0
                    ? `${rewardTiers[currentTierIndex].count} referrals`
                    : `${rewardTiers[rewardTiers.length - 1].count}+ referrals`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progressToNextTier}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  bgcolor: "#f5f5f5",
                  "& .MuiLinearProgress-bar": {
                    bgcolor: "#FF5733",
                  },
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ color: "#555", fontWeight: 500 }}
                >
                  {currentTierIndex >= 0
                    ? `${
                        nextTierCount - currentReferrals
                      } more referrals to unlock ${
                        rewardTiers[currentTierIndex].reward
                      }`
                    : "You've reached the highest tier!"}
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: 600, color: "#333" }}
            >
              Reward Tiers
            </Typography>
            <Grid container spacing={2}>
              {rewardTiers.map((tier, index) => (
                <Grid item xs={6} sm={3} key={index}>
                  <Card
                    elevation={currentReferrals >= tier.count ? 3 : 1}
                    sx={{
                      textAlign: "center",
                      bgcolor:
                        currentReferrals >= tier.count
                          ? "#FFF4F0"
                          : "background.paper",
                      border:
                        currentReferrals >= tier.count
                          ? "1px solid #FFDDD1"
                          : "1px solid #eaeaea",
                      opacity: currentReferrals >= tier.count ? 1 : 0.8,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: 3,
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        component="div"
                        sx={{ fontWeight: 600, color: "#FF5733" }}
                      >
                        {tier.count}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        referrals
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: "#333" }}
                      >
                        {tier.reward}
                      </Typography>
                      {currentReferrals >= tier.count && (
                        <Chip
                          icon={
                            <EmojiEventsIcon
                              sx={{ color: "white !important" }}
                            />
                          }
                          label="Unlocked"
                          size="small"
                          sx={{
                            mt: 1,
                            bgcolor: "#28a745",
                            color: "white",
                            "& .MuiChip-icon": {
                              color: "white",
                            },
                          }}
                        />
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Referral History */}
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              borderRadius: "12px",
              border: "1px solid #f0f0f0",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "#333", fontWeight: 600 }}
            >
              Referral History
            </Typography>
            <TableContainer
              sx={{
                maxHeight: 400,
                "&::-webkit-scrollbar": {
                  width: "10px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#ccc",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#aaa",
                },
              }}
            >
              <Table>
                <TableHead sx={{ bgcolor: "#f5f5f5" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Reward</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Service</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referralData.map((row, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{ "&:hover": { bgcolor: "#FFF9F7" } }}
                    >
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>
                        <Chip
                          label={row.status}
                          size="small"
                          color={getStatusColor(row.status)}
                          sx={{
                            fontWeight: 500,
                            ...(row.status === "Converted" && {
                              bgcolor: "#e8f5e9",
                              color: "#2e7d32",
                              border: "1px solid #c8e6c9",
                            }),
                            ...(row.status === "Pending" && {
                              bgcolor: "#fff8e1",
                              color: "#f57c00",
                              border: "1px solid #ffecb3",
                            }),
                            ...(row.status === "Expired" && {
                              bgcolor: "#ffebee",
                              color: "#c62828",
                              border: "1px solid #ffcdd2",
                            }),
                          }}
                        />
                      </TableCell>
                      <TableCell>{row.reward}</TableCell>
                      <TableCell>
                        {row.service !== "-" ? (
                          <Chip
                            icon={
                              <FlightTakeoffIcon sx={{ fontSize: "1rem" }} />
                            }
                            label={row.service}
                            size="small"
                            variant="outlined"
                            sx={{
                              color: "#555",
                              borderColor: "#ccc",
                            }}
                          />
                        ) : (
                          row.service
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </>
      )}

      {activeTab === 1 && (
        <>
          {/* Rewards Dashboard */}
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              mb: 4,
              borderRadius: "12px",
              border: "1px solid #f0f0f0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
                flexWrap: { xs: "wrap", sm: "nowrap" },
                gap: 2,
              }}
            >
              <Typography variant="h6" sx={{ color: "#333", fontWeight: 600 }}>
                Your Rewards Dashboard
              </Typography>
              <Button
                variant="contained"
                startIcon={<RedeemIcon />}
                disabled={metrics.totalEarned === "₹0"}
                sx={{
                  bgcolor: "#FF5733",
                  "&:hover": {
                    bgcolor: "#E64A2E",
                  },
                  "&.Mui-disabled": {
                    bgcolor: "#f5f5f5",
                    color: "#999",
                  },
                }}
              >
                Redeem Rewards
              </Button>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card
                  variant="outlined"
                  sx={{
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  }}
                >
                  <CardContent>
                    <Typography
                      sx={{ color: "#666", fontWeight: 500 }}
                      gutterBottom
                    >
                      Total Rewards Earned
                    </Typography>
                    <Typography
                      variant="h4"
                      component="div"
                      sx={{ color: "#FF5733", fontWeight: 700 }}
                    >
                      {metrics.totalEarned}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
                      Pending: {metrics.pendingRewards}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card
                  variant="outlined"
                  sx={{
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  }}
                >
                  <CardContent>
                    <Typography
                      sx={{ color: "#666", fontWeight: 500 }}
                      gutterBottom
                    >
                      Current Tier
                    </Typography>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{ color: "#FF5733", fontWeight: 600 }}
                    >
                      {currentTierIndex > 0
                        ? `Tier ${currentTierIndex}: ${
                            rewardTiers[currentTierIndex - 1].reward
                          }`
                        : "No tier unlocked yet"}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
                      {currentTierIndex >= 0
                        ? `Next: ${rewardTiers[currentTierIndex].reward}`
                        : "You've reached the highest tier!"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Box
              sx={{
                mt: 4,
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, color: "#333" }}
              >
                Reward History
              </Typography>
              <Chip
                label="All benefits apply to Airport Service Bookings"
                size="small"
                icon={<LuggageIcon sx={{ fontSize: "1rem" }} />}
                sx={{ bgcolor: "#f5f5f5", color: "#666" }}
              />
            </Box>

            <TableContainer>
              <Table
                size="small"
                sx={{ border: "1px solid #f0f0f0", borderRadius: "8px" }}
              >
                <TableHead sx={{ bgcolor: "#f5f5f5" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Amount</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow hover sx={{ "&:hover": { bgcolor: "#FFF9F7" } }}>
                    <TableCell>2024-04-15</TableCell>
                    <TableCell>Referral reward for Priya Sharma</TableCell>
                    <TableCell sx={{ color: "#FF5733", fontWeight: 500 }}>
                      ₹200
                    </TableCell>
                    <TableCell>
                      <Chip
                        label="Applied"
                        size="small"
                        sx={{
                          bgcolor: "#e8f5e9",
                          color: "#2e7d32",
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow hover sx={{ "&:hover": { bgcolor: "#FFF9F7" } }}>
                    <TableCell>2024-04-05</TableCell>
                    <TableCell>Referral reward for Neha Gupta</TableCell>
                    <TableCell sx={{ color: "#FF5733", fontWeight: 500 }}>
                      ₹200
                    </TableCell>
                    <TableCell>
                      <Chip
                        label="Applied"
                        size="small"
                        sx={{
                          bgcolor: "#e8f5e9",
                          color: "#2e7d32",
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow hover sx={{ "&:hover": { bgcolor: "#FFF9F7F7" } }}>
                    <TableCell>2024-03-28</TableCell>
                    <TableCell>Referral reward for Vikram Singh</TableCell>
                    <TableCell sx={{ color: "#FF5733", fontWeight: 500 }}>
                      ₹200
                    </TableCell>
                    <TableCell>
                      <Chip
                        label="Applied"
                        size="small"
                        sx={{
                          bgcolor: "#e8f5e9",
                          color: "#2e7d32",
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow hover sx={{ "&:hover": { bgcolor: "#FFF9F7" } }}>
                    <TableCell>2024-04-20</TableCell>
                    <TableCell>Pending reward for Amit Patel</TableCell>
                    <TableCell sx={{ color: "#FF5733", fontWeight: 500 }}>
                      ₹200
                    </TableCell>
                    <TableCell>
                      <Chip
                        label="Pending"
                        size="small"
                        sx={{
                          bgcolor: "#fff8e1",
                          color: "#f57c00",
                          fontWeight: 500,
                        }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>

          {/* Performance Metrics */}
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, md: 4 },
              mb: 4,
              borderRadius: "12px",
              border: "1px solid #f0f0f0",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "#333", fontWeight: 600 }}
            >
              Your Referral Performance
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <Card
                  variant="outlined"
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      bgcolor: "#FF5733",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <TrendingUpIcon sx={{ color: "white", fontSize: 30 }} />
                  </Box>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 700, color: "#333" }}
                  >
                    {metrics.conversionRate}%
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#666", mt: 1, fontWeight: 500 }}
                  >
                    Conversion Rate
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card
                  variant="outlined"
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      bgcolor: "#FF5733",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <AccessTimeIcon sx={{ color: "white", fontSize: 30 }} />
                  </Box>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 700, color: "#333" }}
                  >
                    {metrics.avgTimeToConversion}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#666", mt: 1, fontWeight: 500 }}
                  >
                    Avg. Time to Conversion
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card
                  variant="outlined"
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      bgcolor: "#FF5733",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <LeaderboardIcon sx={{ color: "white", fontSize: 30 }} />
                  </Box>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 700, color: "#333" }}
                  >
                    {metrics.topChannel}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#666", mt: 1, fontWeight: 500 }}
                  >
                    Top Channel
                  </Typography>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card
                  variant="outlined"
                  sx={{
                    p: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    bgcolor: "#FFF9F7",
                    border: "1px solid #FFDDD1",
                    borderRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      bgcolor: "#FF5733",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    <BarChartIcon sx={{ color: "white", fontSize: 30 }} />
                  </Box>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 700, color: "#333" }}
                  >
                    {currentReferrals}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#666", mt: 1, fontWeight: 500 }}
                  >
                    Total Referrals
                  </Typography>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}

      {/* Share Modal */}
      <Dialog
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF5733",
            color: "white",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Share Your Referral Link
          <IconButton
            onClick={() => setShareModalOpen(false)}
            sx={{ color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 500 }}>
            Choose how you'd like to share:
          </Typography>

          <Box sx={{ mt: 3, mb: 4 }}>
            <Typography
              variant="subtitle2"
              gutterBottom
              sx={{ fontWeight: 600, color: "#555" }}
            >
              Quick Share
            </Typography>
            <Grid container spacing={2}>
              <Grid item>
                <IconButton
                  onClick={() => handleShare("WhatsApp")}
                  sx={{
                    bgcolor: "#25D366",
                    color: "white",
                    "&:hover": { bgcolor: "#1da851" },
                  }}
                >
                  <WhatsAppIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton
                  onClick={() => handleShare("Facebook")}
                  sx={{
                    bgcolor: "#1877F2",
                    color: "white",
                    "&:hover": { bgcolor: "#1559b3" },
                  }}
                >
                  <FacebookIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton
                  onClick={() => handleShare("Twitter")}
                  sx={{
                    bgcolor: "#1DA1F2",
                    color: "white",
                    "&:hover": { bgcolor: "#1781c8" },
                  }}
                >
                  <TwitterIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton
                  onClick={() => handleShare("LinkedIn")}
                  sx={{
                    bgcolor: "#0077B5",
                    color: "white",
                    "&:hover": { bgcolor: "#005f92" },
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton
                  onClick={() => handleShare("Email")}
                  sx={{
                    bgcolor: "#757575",
                    color: "white",
                    "&:hover": { bgcolor: "#5a5a5a" },
                  }}
                >
                  <EmailIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle2"
              gutterBottom
              sx={{ fontWeight: 600, color: "#555" }}
            >
              Or use a pre-written message
            </Typography>
            <Grid container spacing={2}>
              {campaignTemplates.map((template, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card
                    variant="outlined"
                    onClick={() => selectTemplate(template.message)}
                    sx={{
                      p: 2,
                      cursor: "pointer",
                      borderColor: "#e0e0e0",
                      "&:hover": {
                        borderColor: "#FF5733",
                        bgcolor: "#FFF9F7",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "#FFDDD1",
                          color: "#FF5733",
                          mr: 2,
                          width: 32,
                          height: 32,
                        }}
                      >
                        {template.icon}
                      </Avatar>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: "#333" }}
                      >
                        {template.name}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#666", fontSize: "0.8rem", mt: 1 }}
                    >
                      {template.message.substring(0, 80)}...
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setCustomMessageOpen(true)}
              sx={{
                bgcolor: "#FF5733",
                py: 1.5,
                "&:hover": { bgcolor: "#E64A2E" },
              }}
            >
              Customize Message
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Custom Message Dialog */}
      <Dialog
        open={customMessageOpen}
        onClose={() => setCustomMessageOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF5733",
            color: "white",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Customize Your Message
          <IconButton
            onClick={() => setCustomMessageOpen(false)}
            sx={{ color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 500 }}>
            Sharing via:{" "}
            <span style={{ color: "#FF5733" }}>{selectedChannel}</span>
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            sx={{ mt: 3 }}
            inputProps={{
              style: {
                fontSize: "0.9rem",
                lineHeight: "1.5",
              },
            }}
          />

          <Box sx={{ mt: 3 }}>
            <Typography
              variant="subtitle2"
              gutterBottom
              sx={{ fontWeight: 600, color: "#555" }}
            >
              Your referral link will be automatically included
            </Typography>
            <Box
              sx={{
                p: 2,
                bgcolor: "#f5f5f5",
                borderRadius: "4px",
                wordBreak: "break-all",
                fontSize: "0.8rem",
              }}
            >
              {referralLink}
            </Box>
          </Box>

          <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setCustomMessageOpen(false)}
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSendCustomMessage}
              sx={{
                bgcolor: "#FF5733",
                "&:hover": { bgcolor: "#E64A2E" },
              }}
            >
              Send
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
};
